import {Brand} from "../../../models/Brand";
import smallPiginiLogo from '../../../assets/img/pigin_logo_without_text.jpeg'
import smallExcelsiorLogo from '../../../assets/img/excelsior_logo_without_text.png'
import { GiAccordion } from "react-icons/gi";

interface Props {
    brand: Brand,
    style: {}
}

const BrandIcon = ({brand, style}: Props) => {

    return (
        brand === Brand.Pigini ? <img src={smallPiginiLogo} style={style} /> :
        brand === Brand.Excelsior ? <img src={smallExcelsiorLogo} style={style} /> :
        <GiAccordion style={style} />
    )
}

export default BrandIcon;